import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { catchError, map } from 'rxjs/operators';
import { Items } from '../models/items';
import { Merchant } from '../models/merchant';
import { IdName } from '../models/id-name';

@Injectable({ providedIn: 'root' })
export class MerchantService {

    merchantGlobalInfo: any;
    merchantContactInfo: any;
    isSaveNeeded: boolean = false;

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService
    ) { }

    merchantSubject = new Subject<any[]>();
    merchantSubjectPager = new Subject<Items<Merchant>>();

    getMerchantGlobalInfo() {
        return this.merchantGlobalInfo;
    }

    setMerchantGlobalInfo(merchantGlobalInfo) {
        this.merchantGlobalInfo = merchantGlobalInfo;
        this.isSaveNeeded = true;
        this.merchantSubject.next([this.isSaveNeeded]);
    }

    getMerchantContactInfo() {
        return this.merchantContactInfo;
    }

    setMerchantContactInfo(merchantContactInfo) {
        this.merchantContactInfo = merchantContactInfo;
        this.isSaveNeeded = true;
        this.merchantSubject.next([this.isSaveNeeded]);
    }

    emitMerchantPager(merchants) {
        this.merchantSubjectPager.next(merchants);
    }

    getAllMerchants(): Observable<Items<Merchant>> {
        let pager: {} = [];
        pager["sort"] = "id,ASC";
        pager["size"] = 200;

        return this.findByCriteria({}, pager, false);
    }

    getMerchantById(id): Observable<Merchant> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlMerchant}/${id}`).pipe(catchError(err => {
            if (err.status == "404") {
                console.log("error", err);
            } else {
                this.notifService.notifyErrorWithDetailFromApi('ERROR_MERCHANT_API', err);
            }
            let emptyItem = new Merchant();
            emptyItem.name = "N/A";
            return of(emptyItem);
        }));
    }

    getMerchantsByIds(listMerchantsId): Observable<Array<Merchant>> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlMerchant}/merchantsid?ids=${listMerchantsId}`).pipe(catchError(err => {
            console.log("error byids", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MERCHANT_API', err);
            let emptyList = new Array<Merchant>();
            return of(emptyList);
        }));
    }

    getMerchantNamesByIds(listMerchantsId): Observable<Array<IdName>> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlMerchant}/merchantsnames?ids=${listMerchantsId}`).pipe(catchError(err => {
            console.log("error byids", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MERCHANT_API', err);
            return of([]);
        }));
    }

    deleteMerchant(id): Observable<Merchant> {
        return this.http.delete<Merchant>(`${this.configService.config.urlAPI.urlMerchant}/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MERCHANT_API', err);
            return of(null);
        }));
    }

    updateMerchant(): Observable<Merchant> {
        let newMerchant = { ...this.getMerchantGlobalInfo(), ...this.getMerchantContactInfo() };
        return this.http.put<Merchant>(this.configService.config.urlAPI.urlMerchant, newMerchant).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MERCHANT_API', err);
            return of(null);
        }));
    }

    createMerchant(merchant): Observable<Merchant> {
        return this.http.post<Merchant>(this.configService.config.urlAPI.urlMerchant, merchant).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MERCHANT_API', err);
            return of(null);
        }));
    }

    isExternalRefExists(externalRef: string): Observable<boolean> {
        if (externalRef === '') {
            return of(false);
        }
        const criteria = {
            'externalRef': externalRef
        }
        return this.findByCriteria(criteria, {}, true).pipe(map(res => { 
            return res.content.length > 0 && res.content.filter((merchant) => merchant.externalRef === externalRef).length > 0;
        }));
    }

    isEmailExists(email: string): Observable<boolean> {
        if (email === '') {
            return of(false);
        }
        const criteria = {
            'contact.email': email
        }
        return this.findByCriteria(criteria, {}, false).pipe(map(res => { 
            return res.content.length > 0 && res.content.filter((merchant) => merchant.contact.email === email).length > 0
        }));
    }

    findByCriteria(criteria, pager, isDeletedIncluded:boolean): Observable<Items<Merchant>> {
        let params = {};
        Object.assign(params, pager, criteria, {includeDeleted:isDeletedIncluded});

        return this.http.get<any>(this.configService.config.urlAPI.urlMerchant, { params: params }).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_MERCHANT_API', err);
            let emptyList = new Items<Merchant>();
            emptyList.content = [];
            return of(emptyList);
        }));
    }
}